import Button from './FitButton';
import React from 'react';
import {  } from '@mui/material';
import { colors, shape } from '../../design/tokens';

// Use for ordinary page and sheet actions. Keep specialized FABs and provider login buttons separate.
export default function AppButton({ tone = 'primary', sx, ...props }) {
    const primary = tone === 'primary';
    return (
        <Button
            variant={primary ? 'contained' : 'outlined'}
            {...props}
            sx={{
                minHeight: shape.controlMinHeight,
                borderRadius: `${shape.controlRadius}px`,
                fontSize: '1rem',
                fontWeight: 700,
                textTransform: 'none',
                boxShadow: 'none',
                bgcolor: primary ? colors.brand : colors.surface,
                color: primary ? colors.brandText : colors.text,
                borderColor: primary ? 'transparent' : colors.disabled,
                '&:hover': {
                    bgcolor: primary ? colors.brandHover : colors.surfaceMuted,
                    borderColor: primary ? 'transparent' : colors.disabled,
                    boxShadow: 'none',
                },
                '&:active': { transform: 'scale(0.98)' },
                '&:focus-visible': { outline: `2px solid ${colors.brandDark}`, outlineOffset: 2 },
                '&.Mui-disabled': { bgcolor: colors.disabled, color: '#888', borderColor: colors.disabled },
                ...sx,
            }}
        />
    );
}
